export const aboutInfo = {
  brandName: "红桃影院",
  slogan: "你的欢乐源泉，综艺精彩不停",
  founded: "2018年",
  mission: "红桃影院致力于为广大用户提供高品质、正能量的综艺节目在线观看体验。我们汇聚国内外热门综艺、真人秀、脱口秀等多元内容，打造一站式综艺娱乐平台。每一档节目都经过精心挑选，确保内容有趣、有料、有温度。",
  vision: "成为华语地区最具影响力的综艺内容平台，让每一个热爱欢笑的人都能在这里找到属于自己的快乐时光。",
  values: [
    { title: "内容为王", description: "严格筛选每一档节目，坚持提供优质、正能量的综艺内容，拒绝低俗和粗糙。" },
    { title: "用户体验至上", description: "高清流畅的播放体验、简洁直观的界面设计，让用户轻松找到想看的节目。" },
    { title: "创新不止", description: "持续引入新技术、新玩法，不断优化产品体验，让看综艺变得更有趣。" },
    { title: "责任担当", description: "作为文化传播平台，我们坚持正确的价值导向，传播积极向上的娱乐文化。" },
  ],
  reputation: [
    {
      name: "张先生",
      avatar: "ri-user-3-line",
      rating: 5,
      comment: "每天下班回家就打开红桃影院看综艺，画质清晰不卡顿，分类也很全。特别喜欢真人秀专区，推荐给身边很多朋友了！",
      date: "2026-07-30",
    },
    {
      name: "李女士",
      avatar: "ri-user-3-line",
      rating: 5,
      comment: "之前一直找不到好看的搞笑综艺，朋友推荐了红桃影院，真的发现了宝藏！脱口秀大会和吐槽大会都太好笑了，每周都在追。",
      date: "2026-07-28",
    },
    {
      name: "王同学",
      avatar: "ri-user-3-line",
      rating: 5,
      comment: "作为一个综艺爱好者，红桃影院的分类做得太好了，真人秀、音乐综艺、旅行综艺应有尽有。而且更新很及时，新节目一上线就能看到。",
      date: "2026-07-25",
    },
    {
      name: "赵女士",
      avatar: "ri-user-3-line",
      rating: 4,
      comment: "界面简洁好看，没有乱七八糟的广告弹窗。希望后续能增加更多海外综艺资源，那就更完美了！目前已经很满意了。",
      date: "2026-07-22",
    },
    {
      name: "刘先生",
      avatar: "ri-user-3-line",
      rating: 5,
      comment: "全家都在用红桃影院看综艺，爸妈喜欢看旅行综艺，我喜欢看脱口秀，孩子也爱看竞技类的。一个平台满足全家需求，太棒了！",
      date: "2026-07-20",
    },
    {
      name: "陈女士",
      avatar: "ri-user-3-line",
      rating: 5,
      comment: "红桃影院的推荐算法很准，经常给我推荐一些冷门但超好看的综艺。已经在这里发现了不少宝藏节目，真心推荐！",
      date: "2026-07-18",
    },
  ],
  stats: [
    { number: "5000万+", label: "累计用户" },
    { number: "200+", label: "热门综艺" },
    { number: "10000+", label: "高清剧集" },
    { number: "99.5%", label: "用户好评率" },
  ],
  contact: {
    email: "contact@hongtao-movie.com",
    phone: "400-888-6666",
    address: "北京市朝阳区红桃文化创意产业园A座",
    wechat: "红桃影院官方",
    weibo: "@红桃影院",
  },
};